export const hiddenClass = 'c24-travel-hidden';
export const cookieConsent = {
    cookieId: 'c24consent',
    consentEvent: 'c24consent',
};
